import { useEffect, useRef, useState } from "react";
import { CookieConsent } from "@/components/CookieConsent";
import SEO from "@/components/SEO";
import { MissionHubSection as CorporateMissionHubSection } from "@/components/home/CorporateMissionHub";
import { AIAssistantSection as CorporateAIAssistant } from "@/components/home/CorporateAIAssistant";
import { CorporateHeroSection } from "@/components/home/CorporateLandingHero";
import { VolunteeringHubSection } from "@/components/home/VolunteeringHubSection";
import { CSRHubSection } from "@/components/home/CSRHubSection";
import { GIVFBanner } from "@/components/home/GIVFBanner";
import { Helmet } from "react-helmet-async";
import CoraaAIDialog from "@/components/givf/CoraaAIDialog";

const Corporate = () => {
  const sections = useRef<(HTMLDivElement | null)[]>([]);
  const [isCoraaDialogOpen, setIsCoraaDialogOpen] = useState(false);

  return (
    <>
      <GIVFBanner />
      <SEO
        title="CauseConnect - Empowering Corporates with Technology"
        description="CauseConnect helps corporates leverage technology to maximize their impact. Our platform provides tools for volunteer management, fundraising, and community engagement."
      />
      <div className="min-h-screen bg-white relative">
        <Helmet>
          <title>CauseConnect - The AI Growth Engine for Corporates</title>
        </Helmet>

        {/* <TechGrantBanner /> Removed for Corporate page */}
        <main>
          <CorporateHeroSection />
          <VolunteeringHubSection />
          <CSRHubSection />
          {/* <ESGHubSection /> */}
          {/* Removed ProblemSection from Corporate page */}

          <div ref={(el) => (sections.current[1] = el)}>
            <CorporateMissionHubSection />
          </div>

          {/* <div ref={el => sections.current[2] = el}>
            <CampaignSection />
          </div> */}

          <div ref={(el) => (sections.current[3] = el)}>
            <CorporateAIAssistant reverse={true} />
          </div>

          {/* <div ref={el => sections.current[5] = el}>
            <CorporateKnowledgeVault />
          </div> */}

          {/* Removed ImpactCalculatorSection, PricingSection, StepsSection */}
        </main>
        <CookieConsent />
        <CoraaAIDialog
          open={isCoraaDialogOpen}
          onClose={() => setIsCoraaDialogOpen(false)}
        />
      </div>
    </>
  );
};

export default Corporate;
